export default __webpack_public_path__ + "static/media/aerial-command-truck.79c906a6.webp";